import { resetTokenApi } from "../../apis/auth.api";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import { accessToken, refreshToken } from "../../utils/main";
import { callSnackBar } from "./snackbarAction";
import { signOutAction } from "./userReducerAction";

const getErrorMessage = (response) => {
  return (
    response?.response?.data?.data?.[0]?.msg ||
    response?.response?.data?.message ||
    response?.data?.message ||
    response?.data?.[0]?.message ||
    response?.message ||
    "OOPS! Something went wrong"
  );
};

export const callApiAction = (
  asyncFun,
  onSuccess = () => {},
  onError = () => {},
  isFile = false,
) => {
  return async (dispatch, getState) => {
    try {
      const response = await asyncFun();
      console.log("API response:", response);
      if (response.status === 1 || (isFile && response.status !== 0)) {
        if (isFile) {
          onSuccess(response);
        } else await onSuccess(response.data);
      } else {
        console.error("API call failed with response:", response);
        if (response.code === 400) {
          onError(getErrorMessage(response));
        } else if (response.code === 401) {
          const resetFunResponse = await resetTokenApi();
          if (resetFunResponse.status === 1) {
            accessToken.set(resetFunResponse.data.accessToken);
            refreshToken.set(resetFunResponse.data.refreshToken);

            dispatch(callApiAction(asyncFun, onSuccess, onError));
          } else if (resetFunResponse.code === 401) {
            dispatch(signOutAction());
          }
        } else if (response.code === 403) {
          dispatch(
            callSnackBar(
              "Your session has expired due to unautherized access",
              SNACK_BAR_VARIETNS.error,
            ),
          );
          dispatch(signOutAction());
        } else if (response.code === 406) {
          onError(response.message, 406, response.data);
        } else {
          const errorMessage = getErrorMessage(response);
          dispatch(callSnackBar(errorMessage, SNACK_BAR_VARIETNS.error));
          onError(errorMessage);
        }
      }
    } catch (e) {
      const errorMessage = e?.response?.data?.message || e?.message;
      onError(errorMessage);
      dispatch(
        callSnackBar(
          errorMessage || "OOPS! Something went wrong",
          SNACK_BAR_VARIETNS.error,
        ),
      );
    }
  };
};
